import React, { useRef, useState } from "react";
import { showLoader, removeLoader, DKIcons, DKIcon, DKLabel, showAlert } from "deskera-ui-library";
import Utility from "../utility/Utility";
import AttachmentService from "../services/AttachmentService";
import i18next from "i18next";

const FileUploadField = (props) => {
	const inputId = `file-input-${props.fieldId}`;
	const buttonId = `choose-file-button-${props.fieldId}`;

    const inputRef = useRef();
	const [fileState, setFileState] = useState(null);

    const onFileChange = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            uploadDocument(event.target.files);
        }
    }

	const uploadDocument = (files) => {
		if (files && files[0]) {
			showLoader("Uploading files... Please wait");
			AttachmentService.getUploadFileURL(files[0], props.entity).then(
				(response) => {
					removeLoader();
					setFileState({
						title: files[0].name,
						path: response.relativePath,
					});
					props.onChange(response.relativePath);
				},
				(error) => {
					if(error?.status === 500 && error?.message?.includes("CONTENT_TYPE_NOT_ALLOWED")) {
						showAlert(i18next.t('FAIL_TO_UPLOAD'), i18next.t('FILE_FORMAT_TYPE_ERROR_MSG'));
					}
					removeLoader();
				}
			);
		}
	};

	const getFileDetails = (fileState) => {
		return (
			<div style={{ marginTop: "30px" }}>
				<div style={{ marginTop: "-20px", float: "left" }}>File Details</div>
				<div className="bg-gray1 border-radius-m border-m">
					<div className="d-flex justify-content-between p-m">
						<div
							className="d-flex cursor-hand"
							onClick={() => window.open(fileState.path, "_blank")}
						>
							<DKIcon
								className="ic-s mr-s"
								src={Utility.getFileIcon(fileState.title)}
							/>
							<span className="word-break-all">{fileState.title}</span>
						</div>
						<DKIcon
							className="ic-s mr-s cursor-hand"
							src={DKIcons.ic_delete}
							onClick={() => {
								setFileState(null);
								props.onChange("");
                                if (inputRef.current) {
                                    inputRef.current.value = "";
                                }
							}}
						/>
					</div>
				</div>
			</div>
		);
	};

	return (
		<div className="parent-width">
			<DKLabel
				className="mb-xs mt-m"
				text={props.required ? `${props.title} *` : props.title}
			/>
			<div
				className={"p-m border-radius-m mb-l"}
				style={{
					border: props.invalid
						? "1.2px solid rgba(201, 34, 45, 0.7)"
						: "1.2px solid rgb(235, 235, 235)",
				}}
			>
				<div className="border-radius-m">
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
							textAlign: "left",
						}}
					>
						<div
							className="mr-m"
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "between",
								textAlign: "left",
							}}
						>
							<button
								id={buttonId}
								type="button"
								style={{
									borderRadius: "8px",
									height: "30px",
									width: "130px",
									backgroundColor: "#fff",
									fontWeight: 600,
									border: "1px solid #dcdcdc",
									fontSize: "13px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									marginRight: "5px",
									cursor: "pointer",
								}}
								onClick={() => {
                                    if (inputRef.current) {
                                        inputRef.current.click();
                                    }
								}}
							>
								<img src={DKIcons.ic_document} style={{ height: "16px" }} />
								<span style={{ marginLeft: "5px" }}>{props.inputText}</span>
							</button>
							<span
								style={{
									overflowWrap: "break-word",
									whiteSpace: "pre-wrap",
									fontSize: "13px",
									textAlign: "left",
								}}
							>
								{props.acceptText}
							</span>
						</div>
					</div>
					<input
                        ref={inputRef}
						className="d-none"
						type="file"
						name="file"
						id={inputId}
						required
						style={{
							visibility: "hidden",
						}}
						accept={props.accept}
                        onChange={onFileChange}
					/>
				</div>
				{fileState && getFileDetails(fileState)}
			</div>
		</div>
	);
};

export default FileUploadField;
